import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";

const topperYears = ["2025-26", "2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19", "2017-18"];
const linkPdfData = ["2025-26.pdf", "2024-25.pdf", "2023-24.pdf", "2022-23.pdf", "2021-22.pdf", "2020-21.pdf", "2019-20.pdf", "2018-19.pdf", "2017-18.pdf"];

const SchoolTopper = () => {
    return (
        <>
            <Header />
            <Breadcrumb mid="Results" breadcrumbName="School Toppers" />

            <div className="innerSection">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h1>School Toppers</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <Link to="/topperX">
                                <div className="topper-pg">
                                    <h3>ICSE Toppers</h3>
                                    <i className="bi bi-mortarboard"></i>
                                    <p>View Toppers</p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-6">
                            <Link to="/topperXII">
                                <div className="topper-pg">
                                    <h3>ISC Toppers</h3>
                                    <i className="bi bi-mortarboard"></i>
                                    <p>View Toppers</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h2>Result Analysis</h2>
                                </div>
                            </div>
                        </div>
                        {topperYears.map((year, index) => (
                            <div className="col-md-4" key={year}>
                                <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/pdf/result_analysis_${linkPdfData[index]}`}>
                                    <div className="topper-pg">
                                        <h3>{year}</h3>
                                        <p>View Toppers</p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default SchoolTopper;